<template>
    <header class="site-header" v-if="!Edicao">
        <div class="logo">
            <img src="@/assets/logoHeader.png" v-if="nomeEmpresa == 'BRITECH' || nomeEmpresa == 'DNWAYS_DEMO_Y' || nomeEmpresa == 'DNWAYS_DEMO_X'" style="filter: invert(60%);" />
            <img src="@/assets/dnways.png" v-if="nomeEmpresa == 'Vortex'" style="width: 100%; height: 100%;" />
            <img src="@/assets/logoActual_v2.png" v-if="nomeEmpresa == 'ACTUAL'" style="width: 90%; height: 90%;" />
            <img src="@/assets/logogenial.png" v-if="nomeEmpresa == 'GENIAL'" style="width: 100%; height: 100%;" />
            <img src="@/assets/logoHeader_rji.png" v-if="nomeEmpresa == 'RJI'" />
            <img src="@/assets/logoLastro.jpg" v-if="nomeEmpresa == 'Lastro'" style="width: 100%; height: 100%;" />
        </div>
        <nav class="navigation">
            <ul>
                <li><button type="button" v-if="configuracaoToken != 'S'" class="button button-light"
                        @click="alterarSenha()" style="cursor: pointer;">Alterar senha</button></li>
                <li><button type="button" @click="logoff" style="cursor: pointer;" class="submit-button">Logoff</button>
                </li>
            </ul>
        </nav>
    </header>
    <div class="container">
        <div class="header">
            <h2 v-if="!Edicao" class="form-header">Cadastro</h2>
            <div class="info__headers" v-if="!Edicao">
                <div class="info__resumo">
                    <div class="navegacao">
                        <a href="javascript:;" class="link" :class="{ active: tab == 0, preenchido: tab > 0 }"
                            @click="selectTab(0)">
                            Dados cadastrais
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 1, preenchido: tab > 1 }"
                            @click="selectTab(1)">
                            Procuradores
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 2, preenchido: tab > 2 }"
                            @click="selectTab(2)">
                            Participantes
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 3, preenchido: tab > 3 }"
                            @click="selectTab(3)">
                            Dados Financeiros
                        </a>
                        <a v-if="nomeEmpresa != 'GENIAL'" href="javascript:;" class="link"
                            :class="{ active: tab === 4, preenchido: tab > 4 }" @click="selectTab(4)">
                            Dados Bancários
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 5, preenchido: tab > 5 }"
                            @click="selectTab(5)">
                            Upload de Documentos
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 6, preenchido: tab > 6 }"
                            @click="selectTab(6)">
                            Declarações
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 7, preenchido: tab > 7 }"
                            @click="selectTab(7)">
                            FATCA
                        </a>
                        <a href="javascript:;" class="link" :class="{ active: tab == 8 }" @click="selectTab(8)">
                            Produtos
                        </a>
                    </div>
                </div>
            </div>
            <div v-if="tab == 0" class="headerAtivo">
                <DadosEmpresa v-if="informacoesEmpresa" ref="form_0" :Edicao="Edicao" />
                <div v-if="!informacoesEmpresa" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 1" class="headerAtivo">
                <Procuradores v-if="informacoesEmpresa" ref="form_1" :Edicao="Edicao" />
                <div v-if="!informacoesEmpresa" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 2" class="headerAtivo">
                <Participantes
                    v-if="informacoesParticipantesRepresentantes && informacoesParticipantes && emissoresDeOrdensBD"
                    :informacoesParticipantes="informacoesParticipantes" ref="form_2" :Edicao="Edicao"
                    :emissoresDeOrdensBD="emissoresDeOrdensBD" />
                <div v-if="!informacoesParticipantes || !emissoresDeOrdensBD || !emissoresDeOrdensBD"
                    class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 3" class="headerAtivo">
                <DadosFinanceiros v-if="informacoesFinanceiras" ref="form_3" :informacoesFinanceiras="informacoesFinanceiras"
                    :Edicao="Edicao" />
                <div v-if="!informacoesFinanceiras" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 4" class="headerAtivo">
                <DadosBancarios v-if="informacoesBancarias" ref="form_4" :Edicao="Edicao" />
                <div v-if="!informacoesBancarias" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 5" class="headerAtivo">
                <UploadDocumentos :Edicao="Edicao" ref="form_5" />
            </div>
            <div v-if="tab == 6" class="headerAtivo">
                <OutrasInformacoes v-if="informacoesDeclaracoes" ref="form_6" :informacoesDeclaracoes="informacoesDeclaracoes"
                    :Edicao="Edicao" />
                <div v-if="!informacoesDeclaracoes" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 7" class="headerAtivo">
                <Fatca v-if="informacoesDeclaracoes" ref="form_7" :informacoesDeclaracoes="informacoesDeclaracoes"
                    :Edicao="Edicao" />
                <div v-if="!informacoesDeclaracoes" class="loading-overlay">
                    <div class="spinner"></div>
                </div>
            </div>
            <div v-if="tab == 8" class="headerAtivo">
                <Produtos :Edicao="Edicao" ref="form_8" />
            </div>

            <div class="footerFormulario">
                <div class="buttonsAcoes">
                    <button class="btnDefault" @click="validarFormularioAtual">{{this.Edicao ? 'Salvar' : 'Salvar e continuar depois'}} </button>
                    <button class="btnBlue btnAvancar" v-if="!Edicao" @click="proximaEtapa">{{this.tab == 8 ? 'Concluir' : 'Avançar'}}</button>
                </div>
            </div>

        </div>
        <ModalAlterarSenha />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DadosEmpresa from './DadosEmpresa.vue';
import Participantes from './Participantes.vue';
import DadosFinanceiros from './DadosFinanceiros.vue';
import DadosBancarios from './DadosBancarios.vue';
import UploadDocumentos from './UploadDocumentos.vue';
import OutrasInformacoes from './OutrasInformacoes.vue';
import Fatca from './Fatca.vue';
import Produtos from './Produtos.vue';
import api from '@/api/axios';
import Cookies from 'js-cookie';
import Procuradores from './Procuradores.vue';
import ModalAlterarSenha from '../AlterarSenha/ModalAlterarSenha.vue'
export default {
    components: {
        DadosEmpresa,
        Participantes,
        DadosFinanceiros,
        DadosBancarios,
        UploadDocumentos,
        OutrasInformacoes,
        Produtos,
        Fatca,
        Procuradores,
        ModalAlterarSenha
    },
    props: ['Edicao'],
    name: 'CadastroFI_Passo_1',
    computed: {
        ...mapGetters({
            user: 'auth/user',
            infoBasica: 'GET_FI_INFO_EMPRESA',
            infoFinanceiro: 'GET_FI_INFO_FINANCEIRO',
            infoBancario: 'GET_FI_INFO_BANCARIO',
            infoDeclaracao: 'GET_FI_INFO_DECLARACAO',
            infoParticipante: 'GET_FI_INFO_PARTICIPANTE',
            infoParticipanteRepresentante: 'GET_FI_INFO_PARTICIPANTE_REPRESENTANTE',
            emissoresDeOrdensBD: 'GET_FI_INFO_EMISSOR_ORDEM',
            salvarInformacoesFI: 'GET_FI_SALVAR_INFO',
            salvarObjInfoBasicas: 'GET_FI_SALVAR_INFO_BASICAS',
            salvarObjInfoFinanceiro: 'GET_FI_SALVAR_INFO_FINANCEIRO',
            salvarObjInfoBancario: 'GET_FI_SALVAR_INFO_BANCARIO',
            salvarObjInfoBancarioAdicional: 'GET_FI_SALVAR_INFO_BANCARIO_ADICIONAL',
            salvarObjInfoDeclaracao: 'GET_FI_SALVAR_INFO_DECLARACAO',
            salvarObjinfoParticipante: 'GET_FI_SALVAR_INFO_PARTICIPANTE',
            salvarDadosEmissorOrdemObj: 'GET_FI_SALVAR_INFO_EMISSOR_ORDEM',
            ObjSalvarInformacoesUploadArquivos: 'GET_SALVAR_INFO_UPLOAD',
            salvarObjInfoParticipanteRepresentante: 'GET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            salvarObjConcluir: 'GET_FICHA_CONCLUIR',
            desabilitarNotificacao: 'GET_SALVAR_INFO_DES_NOTIFICACAO',
            getConfiguracoes: 'GET_CONFIGURACOES',
        }),
        salvouTodasAbas() {
            const { gravarDados } = this;
            return Object.values(gravarDados).every(value => value === 1);
        }
    },
    data() {
        return {
            configuracaoToken: 'n',
            gravarDados: {
                salvarInformacoesFI: 0,
                salvarDadosFinanceiro: 0,
                salvarDadosBancario: 0,
                salvarDadosBancarioAdicional: 0,
                salvarDadosParticipante: 0,
                salvarDadosParticipanteRepresentante: 0,
                salvarDadosDeclaracao: 0,
                salvarInformacoesUpload: 0,
                salvarDadosEmissorOrdem: 0
            },
            nomeEmpresa: '',
            tab: 0,
            informacoesEmpresa: null,
            informacoesBancarias: null,
            informacoesFinanceiras: null,
            informacoesDeclaracoes: null,
            informacoesParticipantes: null,
            informacoesParticipantesRepresentantes: null
        }
    },
    created() {
        this.$store.commit("SET_MODAL_QUESTIONARIO", false);
        this.$store.dispatch('FETCH_QUESTIONARIO_BUSCAR_QUESTOES');
        this.$store.commit('SET_FICHA_CONCLUIR', false);
        this.$store.dispatch('FETCH_CONSULTA_DISCLAIMER');
        this.obterDados();
    },
    async mounted() {
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        this.$store.commit('SET_FI_SALVAR_INFO', false);
        if (!this.Edicao) {
            this.$store.commit('SET_ETAPA_CADASTRO', 0)
        } else {
            this.tab = this.etapaCadastro;
        }
        await this.fetchConfiguracao(['COM TOKEN']);
        this.configuracaoToken = this.getConfiguracoes('COM TOKEN').Valor;

        if(this.infoBasica != null)
            this.informacoesEmpresa = this.infoBasica;

        if(this.infoParticipante != null)
            this.informacoesParticipantes = this.infoParticipante;

        if(this.infoFinanceiro != null)
            this.informacoesFinanceiras = this.infoFinanceiro;

        if(this.infoBancario != null)
            this.informacoesBancarias = this.infoBancario;

        if(this.infoParticipanteRepresentante != null)
            this.informacoesParticipantesRepresentantes = this.infoParticipanteRepresentante;

        if(this.infoDeclaracao != null)
            this.informacoesDeclaracoes = this.infoDeclaracao;

    },
    methods: {
        ...mapActions({
            fetchConfiguracao: 'FETCH_CONFIGURACOES'
        }),
        async validarFormularioAtual(){
            const refName = `form_${this.tab}`;
            const componente = this.$refs[refName];

            if (componente?.salvarInformacoes) {
                componente.salvarInformacoes();
            }
        },
        proximaEtapa(){
            const refName = `form_${this.tab}`;
            const componente = this.$refs[refName];

            if (componente?.proximaEtapa) {
                componente.proximaEtapa();
            }
        },
        async obterDados() {
            await this.$store.dispatch('FETCH_FI_INFO_EMPRESA', this.user.ClienteId);
            await this.$store.dispatch('FETCH_FI_INFO_FINANCEIRO', this.user.ClienteId);
            await this.$store.dispatch('FETCH_FI_INFO_BANCARIO', this.user.ClienteId);
            await this.$store.dispatch('FETCH_FI_INFO_DECLARACAO', this.user.ClienteId);
            await this.$store.dispatch('FETCH_FI_INFO_PARTICIPANTE', this.user.ClienteId);
            await this.$store.dispatch('FETCH_FI_INFO_PARTICIPANTE_REPRESENTANTE', this.user.ClienteId);
            await this.$store.dispatch('FETCH_FI_INFO_EMISSOR_ORDEM', this.user.ClienteId);
            await this.$store.dispatch('FETCH_FI_INFO_PARTICIPANTE_CUSTODIANTE', this.user.ClienteId);
            await this.$store.dispatch('FETCH_CONSULTA_BANCOS');
            await this.$store.dispatch('FETCH_CONSULTA_ATIVIDADES', 'FU');
            await this.$store.dispatch('FETCH_CONSULTA_PAISES');
            await this.$store.dispatch('FETCH_FI_LISTA_PROCURADORES', this.user.ClienteId);
            await this.$store.commit('SET_SALVAR_INFO_UPLOAD', null);
            await this.$store.commit('SET_FI_SALVAR_INFO_BANCARIO', null);
            await this.$store.commit('SET_FI_SALVAR_INFO_BANCARIO_ADICIONAL', null);
        },
        selectTab(tabSelected) {
            if (tabSelected < this.tab) {
                this.tab = tabSelected;
                this.$store.commit('SET_ETAPA_CADASTRO', this.tab)
            }
        },
        formatarValorFinanceiro(valorString) {

            if (valorString === null || valorString === undefined) {
                return 0;
            }

            if (typeof valorString !== 'string') {
                valorString = String(valorString);
            }

            const valorNumerico = parseFloat(
                valorString
                    .replace(/\s/g, '') // remove todos os espaços (inclusive \u00A0)
                    .replace('R$', '')
                    .replace(/\./g, '')
                    .replace(',', '.')
            );

            return isNaN(valorNumerico) ? 0 : valorNumerico;
        },
        logoff() {
            localStorage.removeItem('ClienteId');
            localStorage.removeItem('NomeRazaoSocial');
            localStorage.removeItem('Email');
            localStorage.removeItem('token');
            Cookies.remove('nomeUsuarioLogado');
            this.$router.push({ name: 'UserLogin' });
        },
        async salvarConcluir() {
            if (this.salvarObjConcluir == true) {
                 
                var objConcluir = { ClienteId: this.user.ClienteId };
                this.$store.commit('SET_FI_SALVAR_INFO', false);
                this.$store.commit('SET_FICHA_CONCLUIR', false);
                await api
                    .post('/Fundo/ConcluirCadastro', objConcluir)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$swal({
                                icon: 'success',
                                title: 'Cadastro enviado para análise!',
                                text: 'Em até 48h úteis, a empresa receberá novidades no e-mail informado.',
                            }).then((result) => {
                                if (result.value) {
                                    this.logoff();
                                }
                                this.$store.commit('SET_FI_SALVAR_INFO', false);
                            });
                        }
                    })
                    .catch((error) => {
                        this.$store.commit('SET_FI_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            } else {
                this.$store.commit('SET_FI_SALVAR_INFO', false);
                if (this.desabilitarNotificacao == true) {
                    this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', false);
                } else {
                    if (this.Edicao) {
                        this.$swal({
                            icon: 'warning',
                            title: 'Cadastro atualizado',
                            text: 'As informações serão revisadas pela equipe responsável e você poderá acompanhar essa revisão pelo status.',
                        });
                    } else {
                        this.$swal({
                            icon: 'success',
                            title: 'Alterações realizadas com sucesso!',
                            text: 'Dados informados foram salvos com sucesso.',
                        });
                    }
                }
                this.obterDados();
            }
        },
        async salvarInformacoesUpload() {
            if (!this.salvarInformacoesFI) {
                return;
            }
             
            if (this.ObjSalvarInformacoesUploadArquivos == null) {
                this.gravarDados.salvarInformacoesUpload = 1;
                return;
            } else {
                const data = {
                    documentos: this.ObjSalvarInformacoesUploadArquivos
                };
                await api
                    .post('/cliente/documentos', data)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.$store.dispatch('FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO', this.user.ClienteId);
                            this.gravarDados.salvarInformacoesUpload = 1;
                            this.$store.commit('SET_FI_SALVAR_INFO', false);
                            this.$store.commit('SET_SALVAR_INFO_UPLOAD', null);
                        }
                    })
                    .catch((error) => {
                        this.gravarDados.salvarInformacoesUpload = 2;
                        this.$store.commit('SET_FI_SALVAR_INFO', false);
                        this.$swal({
                            icon: 'error',
                            title: 'Falha ao realizar upload de documentos',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }
        },
        async salvarDadosFinanceiro() {
            if (this.salvarInformacoesFI) {
                 
                if (this.salvarObjInfoFinanceiro == null) {
                    this.gravarDados.salvarDadosFinanceiro = 1;
                    return;
                } else {
                    const dadosFormatados = { ...this.salvarObjInfoFinanceiro };
                    dadosFormatados.FaturamentoMedioMensal = this.formatarValorFinanceiro(dadosFormatados.FaturamentoMedioMensal);
                    dadosFormatados.CapitalSocial = this.formatarValorFinanceiro(dadosFormatados.CapitalSocial);
                    dadosFormatados.Patrimonio = this.formatarValorFinanceiro(dadosFormatados.Patrimonio);
                    await api
                        .post('/Fundo/dadosFinanceiros', dadosFormatados)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.$store.commit('SET_FI_SALVAR_INFO_FINANCEIRO', null);
                                this.gravarDados.salvarDadosFinanceiro = 1;
                                return;
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarDadosFinanceiro = 2;
                            this.$store.commit('SET_FI_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos na aba Informações.',
                                text: `${error.response.data.data[0]}`,
                            });
                        });
                }
            }
        },
        async salvarDadosBancarioAdicional() {
            if (this.salvarInformacoesFI) {
                 
                if (this.salvarObjInfoBancarioAdicional == null) {
                    this.gravarDados.salvarDadosBancarioAdicional = 1;
                    return;
                } else {
                    await api
                        .post('/Fundo/dadosBancarios', this.salvarObjInfoBancarioAdicional)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.$store.dispatch('FETCH_FI_INFO_BANCARIO', this.user.ClienteId);
                                this.$store.commit('SET_FI_SALVAR_INFO_BANCARIO_ADICIONAL', null);
                                this.gravarDados.salvarDadosBancarioAdicional = 1;
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarDadosBancarioAdicional = 2;
                            this.$store.commit('SET_FI_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos na aba Informações.',
                                text: `${error.response.data.data[0]}`,
                            });
                        });
                }
            }
        },
        async salvarDadosBancario() {
            if (this.salvarInformacoesFI) {
                 
                if (this.salvarObjInfoBancario == null) {
                    this.gravarDados.salvarDadosBancario = 1;
                    return;
                } else {
                    await api
                        .post('/Fundo/dadosBancarios', this.salvarObjInfoBancario)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.$store.commit('SET_FI_SALVAR_INFO_BANCARIO', null);
                                this.gravarDados.salvarDadosBancario = 1;
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarDadosBancario = 2;
                            this.$store.commit('SET_FI_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos na aba Informações.',
                                text: `${error.response.data.data[0]}`,
                            });

                        });
                }
            }
        },
        async salvarDadosParticipanteRepresentante() {
            if (this.salvarInformacoesFI) {
                 
                if (this.salvarObjInfoParticipanteRepresentante == null) {
                    this.gravarDados.salvarDadosParticipanteRepresentante = 1;
                    return;
                } else {
                    await api
                        .post('/Fundo/representante', this.salvarObjInfoParticipanteRepresentante)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.$store.dispatch('FETCH_FI_INFO_PARTICIPANTE_REPRESENTANTE', this.user.ClienteId);
                                this.gravarDados.salvarDadosParticipanteRepresentante = 1;
                                this.$store.commit('SET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE', null);
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarDadosParticipanteRepresentante = 2;
                            this.$store.commit('SET_FI_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos de representantes na aba Participantes',
                                text: `${error.response.data.data[0]}`,
                            });

                        });
                }
            }
        },
        async salvarDadosEmissorOrdem() {
            if (this.salvarInformacoesFI) {
                 
                if (this.salvarDadosEmissorOrdemObj == null) {
                    this.gravarDados.salvarDadosEmissorOrdem = 1;
                    return;
                } else {
                    await api
                        .post('/Fundo/pessoaAutorizadaEmitirOrdem', this.salvarDadosEmissorOrdemObj)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.$store.dispatch('FETCH_FI_INFO_EMISSOR_ORDEM', this.user.ClienteId);
                                this.gravarDados.salvarDadosEmissorOrdem = 1;
                                this.$store.commit('SET_FI_SALVAR_INFO_EMISSOR_ORDEM', null);
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarDadosEmissorOrdem = 2;
                            this.$store.commit('SET_FI_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos de emissor de ordem na aba Participantes',
                                text: `${error.response.data.data[0]}`,
                            });

                        });
                }
            }
        },
        alterarSenha() {
            this.$store.commit('SET_ABRIR_ALTERAR_SENHA', true)
        },
        async salvarDadosParticipante() {
            if (this.salvarInformacoesFI) {
                 
                if (this.salvarObjinfoParticipante == null) {
                    this.gravarDados.salvarDadosParticipante = 1;
                    return;
                } else {
                    await api
                        .post('/Fundo/participante', this.salvarObjinfoParticipante)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.gravarDados.salvarDadosParticipante = 1;
                                this.$store.commit('SET_FI_SALVAR_INFO_PARTICIPANTE', null);
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarDadosParticipante = 2;
                            this.$store.commit('SET_FI_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos na aba Participante',
                                text: `${error.response.data.data[0]}`,
                            });

                        });
                }
            }
        },
        async salvarDadosDeclaracao() {
            if (this.salvarInformacoesFI) {
                 
                if (this.salvarObjInfoDeclaracao == null) {
                    this.gravarDados.salvarDadosDeclaracao = 1;
                    return;
                } else {
                    await api
                        .post('/Fundo/declaracoes', this.salvarObjInfoDeclaracao)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.gravarDados.salvarDadosDeclaracao = 1;
                                this.$store.commit('SET_FI_SALVAR_INFO_DECLARACAO', null);
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarDadosDeclaracao = 2;
                            this.$store.commit('SET_FI_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos na aba Declarações',
                                text: `${error.response.data.data[0]}`,
                            });

                        });
                }
            }
        },
        executaProximaEtapa(){
            this.tab = this.etapaCadastro;
        }
    },
    watch: {
        salvouTodasAbas(newVal) {
            if (newVal) {
                this.salvarConcluir();
                if(this.solicitouProximaEtapa){
                    this.executaProximaEtapa();
                    this.$store.commit('SET_FI_SALVAR_INFO', false);
                }
                this.gravarDados.salvarInformacoesFI = 0;
                this.gravarDados.salvarDadosFinanceiro = 0;
                this.gravarDados.salvarDadosBancario = 0;
                this.gravarDados.salvarDadosBancarioAdicional = 0;
                this.gravarDados.salvarDadosParticipante = 0;
                this.gravarDados.salvarDadosParticipanteRepresentante = 0;
                this.gravarDados.salvarDadosDeclaracao = 0;
                this.gravarDados.salvarInformacoesUpload = 0;
                this.gravarDados.salvarDadosEmissorOrdem = 0;
            }
        },
        etapaCadastro() {
            // this.$emit('update:informacoesBasicas', this.infoBasicas);
            if(this.etapaCadastro == 0){
                this.executaProximaEtapa();
            }
            else{
                this.solicitouProximaEtapa = true;
            }
        },
        infoParticipanteRepresentante() {
            this.informacoesParticipantesRepresentantes = this.infoParticipanteRepresentante;
        },
        infoParticipante() {
            this.informacoesParticipantes = this.infoParticipante;
        },
        infoBasica() {
            this.informacoesEmpresa = this.infoBasica;
        },
        infoFinanceiro() {
            this.informacoesFinanceiras = this.infoFinanceiro;
        },
        infoBancario() {
            this.informacoesBancarias = this.infoBancario;
        },
        infoDeclaracao() {
            this.informacoesDeclaracoes = this.infoDeclaracao;
        },
        async salvarInformacoesFI() {
            if (this.salvarInformacoesFI) {
                 
                this.salvarDadosFinanceiro();
                this.salvarDadosBancario();
                this.salvarDadosBancarioAdicional();
                this.salvarDadosParticipante();
                this.salvarDadosParticipanteRepresentante();
                this.salvarDadosDeclaracao();
                this.salvarInformacoesUpload();
                this.salvarDadosEmissorOrdem();
                if (this.salvarObjInfoBasicas == null) {
                    this.gravarDados.salvarInformacoesFI = 1;
                    this.$store.commit('SET_FI_SALVAR_INFO', false);
                    return;
                } else {
                    await api
                        .post('/Fundo/informacaoBasica', this.salvarObjInfoBasicas)
                        .then((retorno) => {
                            if (retorno.status == 200) {
                                this.$store.commit('SET_FI_SALVAR_INFO_BASICAS', null);
                                this.$store.commit('SET_FI_SALVAR_INFO', false);
                                this.gravarDados.salvarInformacoesFI = 1;
                                return;
                            }
                        })
                        .catch((error) => {
                            this.gravarDados.salvarInformacoesFI = 2;
                            this.$store.commit('SET_FI_SALVAR_INFO', false);
                            this.$swal({
                                icon: 'error',
                                title: 'Dados informados inválidos na aba Informações.',
                                text: `${error.response.data.data[0]}`,
                            });
                        });
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

/* Estilos globais */
body,
html {
    height: 100%;
    margin: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
}

.link__before {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid;
    max-width: 70px;
}

.site-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 2rem;
    /* Ajuste conforme necessário */
    background-color: #fff;
    /* Ou qualquer cor de fundo que você deseja */
}

.info__resumo {
    display: flex;
    width: 100%;
    padding-bottom: 9px;

    .navegacao {
        display: flex;
        flex-wrap: wrap;

        .link {
            font-size: 14px;
            text-align: center;
            margin-right: 30px;
            margin-top: 20px;
            color: #667085;
            text-decoration: none;
            font-family: 'Inter', sans-serif;
            font-weight: 500;

            &.first {
                text-align: left;
            }

            &.preenchido {
                font-size: 12px;
                padding-left: 30px;
                font-weight: 500;
                position: relative;
                text-decoration: none;
                // box-shadow: 0 3px 0 #00064F;
                color: #12481f;
                background-image: url('@/assets/aprovado.png');
                /* Atualize com o caminho correto */
                background-repeat: no-repeat;
                background-position: 10px center;
                background-size: 20px 20px;
            }

            &.active {
                font-weight: 500;
                position: relative;
                text-decoration: none;
                // box-shadow: 0 3px 0 #00064F;
                color: #00064F;

                &::after {
                    content: '';
                    /* Necessário para que o pseudo-elemento seja exibido */
                    position: absolute;
                    /* Posiciona o pseudo-elemento em relação ao link */
                    left: 0;
                    /* Alinha à esquerda do link */
                    bottom: -9px;
                    /* Distância do sublinhado em relação à base do texto */
                    width: 100%;
                    /* Largura do sublinhado igual à do elemento link */
                    height: 1px;
                    /* Espessura do sublinhado */
                    background-color: #00064F;
                    /* Cor do sublinhado */
                }
            }
        }
    }
}

.logo img {
    height: 32px;
    /* Ajuste conforme o tamanho desejado para o logo */
    width: 142px;
}

.navigation ul {
    list-style: none;
    display: flex;
    gap: 1rem;
    /* Espaço entre os itens de navegação */
}

.navigation li {
    padding: 0.5rem 1rem;
    /* Ajuste conforme necessário */
}

.navigation a {
    text-decoration: none;
    color: #000;
    /* Cor do texto */
}

.navigation a.router-link-active {
    color: #00235C;
    /* Cor quando o link está ativo */
}

/* Estilização específica para o botão de cadastro */
.navigation a.router-link-exact-active {
    background-color: #00235C;
    /* Cor de fundo para o botão de cadastro */
    color: #fff;
    border-radius: 5px;
    /* Raio da borda para fazer os cantos arredondados */
    padding: 0.5rem 1rem;
}

/* Estilos para o container do login */
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    padding-top: 0px;
    border-radius: 10px;
    background-color: white;
    //   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    width: 80%;
    margin-left: 10%;
}

.logomark {
    width: 54px;
    height: 43.2px;
}

.info__headers {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
    width: 100%;
    border-bottom: 1px solid #EAECF0;
}

.header {
    width: 100%;
    justify-content: flex-start;
}

.header h2 {
    width: 360px;
    /* Largura do elemento */
    height: 38px;
    /* Altura do elemento */
    font-family: 'Gabarito', sans-serif;
    /* Família da fonte, certifique-se de que 'Gabarito' esteja importada ou substitua pelo nome correto da fonte */
    font-weight: 600;
    /* Peso da fonte semibold */
    font-size: 30px;
    /* Tamanho da fonte */
    line-height: 38px;
    /* Altura da linha */
    text-align: left;
    /* Alinhamento do texto ao centro */
    color: #101828;
    margin-bottom: 0px;
}

.header p {
    font-family: 'Inter', sans-serif;
    /* Família da fonte Inter */
    font-weight: 400;
    /* Peso normal da fonte */
    font-size: 16px;
    /* Tamanho da fonte */
    line-height: 24px;
    /* Altura da linha */
    text-align: center;
    /* Alinhamento do texto ao centro */
    color: #6E6E6E;
    /* Cor do texto em cinza (500) - este é um cinza aproximado, ajuste o código hexadecimal conforme necessário */
}

.footer p {
    font-family: 'Inter', sans-serif;
    color: #667085;
    /* Este é um cinza genérico, ajuste conforme necessário */
    font-size: 16px;
    /* Exemplo de tamanho de fonte, ajuste conforme necessário */
    line-height: 24px;
    /* Exemplo de altura de linha, ajuste conforme necessário */
}

.footer a {
    font-weight: 600;
    /* Para 'Cadastre-se', que parece ser mais destacado */
    color: #101828;
    /* Este é o azul padrão de links, ajuste conforme necessário */
    text-decoration: none;
    /* Para sublinhar o link */
}

/* Aplicando estilos de fonte */
button {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
}

.entrar-button {
    color: #667085;
    background: white;
}

input {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px;
    margin-bottom: 16px;
    /* Ajuste para a linha de altura */
    border: 1px solid #ccc;
    border-radius: 8px;
    /* Arredondamento dos inputs */
    box-sizing: border-box;
    /* Garante que o padding não adicione largura extra */
    width: 100%;
    /* Para garantir que os inputs ocupem toda a largura do container */
}

.erroBorder {
    border: 1px solid #E73D3D !important;
    margin-bottom: 0px;
}

.erro {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    margin-top: 0px;
    color: #E73D3D;
}

/* Estilos para os rótulos (labels) do formulário */
.form .input-field label {
    font-family: 'Inter', sans-serif;
    /* Família da fonte Inter */
    font-weight: 500;
    /* Peso médio da fonte */
    font-size: 14px;
    /* Tamanho da fonte */
    line-height: 20px;
    /* Altura da linha */
    color: #344054;
    /* Cor do texto em cinza escuro */
}

/* Estilos para o formulário */
form {
    display: flex;
    flex-direction: column;
}

/* Estilos para os inputs */
input {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

/* Botão de entrar */
button {
    padding: 10px;
    background-color: #00235C;
    ;
    color: white;
    border: none;
    border-radius: 4px;
    text-align: center;
}

/* Media query para telas menores */
@media (max-width: 600px) {
    .login-container {
        margin: 20px;
        padding: 10px;
    }

    input,
    button {
        margin-bottom: 10px;
    }
}

h2 {
    text-align: center;
    margin-bottom: 20px;
}

.forgot-password {
    font-family: 'Inter', sans-serif;
    display: block;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 600;
    color: #00064F;
    text-decoration: none;
}

.signup {
    text-align: center;
    margin-top: 20px;
}

.signup a {
    color: blue;
    text-decoration: none;
}
</style>